var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isNewVersion)?_c('newGsc'):_c('Gsc')
}
var staticRenderFns = []

export { render, staticRenderFns }